import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const Attendance = () => {
    const { attendance } = useSelector(state => state.records);
    const names = ['alumnos', 'egresados', 'profesores', 'administrativos', 'externos', 'total'];
    return(
        <Box display={'flex'}>
            { names.map((n, i) => (
                <Box p={1} flex={'auto'} key={i}>
                    <Typography sx={{ fontSize: '0.45em' }} align="center">{n.toUpperCase()}</Typography>
                    <Typography variant="body1" align="center"><b>{attendance[n]}</b></Typography>
                </Box>
            )) }
        </Box>
    )
}

export default Attendance;